export const validation = {
    required: "এই ঘরটি পূরণ করা আবশ্যক।",
    invalid: "এই তথ্যটি সঠিক নয়।",
    tooMuch: "এই লাইনের বাকি পরিমাণের চেয়ে বেশি।",
    tooShort_one: "কমপক্ষে {{count}}টি অক্ষর দিন।",
    tooShort_other: "কমপক্ষে {{count}}টি অক্ষর দিন।",
    tooLong_one: "সর্বোচ্চ {{count}}টি অক্ষর দেওয়া যাবে।",
    tooLong_other: "সর্বোচ্চ {{count}}টি অক্ষর দেওয়া যাবে।",
};
//# sourceMappingURL=validation.js.map